<template>
    <div v-if="canUseViewAllToggle" class="view-all-toggle" data-testid="top-bar__view-all-toggle">
        <span class="view-all-toggle__label">View all clients and campaigns</span>
        <Switch v-model="showAllContent" size="large">
            <template #open>ON</template>
            <template #close>OFF</template>
        </Switch>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { UiAction } from "@/store/modules/ui";
import { AuthGetters } from "@/store/modules/auth";

export default defineComponent({
    name: "ViewAllToggle",

    computed: {
        canUseViewAllToggle(): boolean {
            return this.$store.getters[AuthGetters.canUseViewAll] as boolean;
        },

        showAllContent: {
            get(): boolean {
                return this.$store.state.ui.showAllContent;
            },

            set(value: boolean) {
                void this.$store.dispatch(UiAction.SetShowAllContent, value);
            }
        }
    }
});
</script>

<style lang="scss">
.view-all-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;

    &__label {
        font-size: 14px;
    }
}
</style>
